module.exports = __webpack_public_path__ + "img/single_bidding_quit.50a093a0.png";